module.exports = __webpack_public_path__ + "img/bum.057d6f70.png";